import React from 'react';
import PropTypes from 'prop-types';
import withToolboxTourTooltip from 'SelfServeTooltipTour/withToolboxTourTooltip';
import TooltipExpandingSection from './TooltipExpandingSection';


export class ExpandingStepsTooltip extends React.PureComponent {
  constructor(props) {
    super(props);

    this.expandSection = this.expandSection.bind(this);
    this.minimizeSection = this.minimizeSection.bind(this);
    this.state = {
      expandedSectionIdx: 0,
    };
  }

  expandSection(expandedSectionIdx) {
    this.setState(() => ({ expandedSectionIdx }));
  }

  minimizeSection() {
    this.setState(() => ({ expandedSectionIdx: -1 }));
  }

  render() {
    return (
      <div className="tooltip-contents">
        {this.props.expandableSections.map((section, index) => (
          <TooltipExpandingSection
            expanded={this.state.expandedSectionIdx === index}
            expandSection={this.expandSection}
            minimizeSection={this.minimizeSection}
            sectionIdx={index}
            sectionText={section.text}
            sectionAdditionalText={section.additionalText}
            sectionImg={section.image}
          />
        ))}
        {!this.props.isToolboxTourHidden &&
          <button
            className="hide-all-tips-button"
            onClick={this.props.hideAllToolboxTips}
          >
            Hide All Tips
          </button>
        }
      </div>
    );
  }
}

ExpandingStepsTooltip.defaultProps = {
  hideAllToolboxTips: () => null,
};

ExpandingStepsTooltip.propTypes = {
  expandableSections: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    additionalText: PropTypes.string,
    image: PropTypes.string.isRequired,
  })).isRequired,
  hideAllToolboxTips: PropTypes.func,
  isToolboxTourHidden: PropTypes.bool.isRequired,
};

export default withToolboxTourTooltip(ExpandingStepsTooltip);



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/ExpandingStepsTooltip.jsx